import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
//import { Address } from 'ngx-google-places-autocomplete/objects/address'
import { ApiService } from 'src/app/core/services/api.service'
import { DentistService } from 'src/app/core/services/dentist.service'
import { changeInputVisibleStateAll, inputSelectAriaCheckActiveState } from '../modal-options-form/form-utils/inputs'
import { RequestHandler } from '../options-utils/request-handler'
//import { GooglePlaceDirective } from 'ngx-google-places-autocomplete'
import { parseAddress } from '../modal-options-form/form-utils/form-utils'
import { NGXLogger } from 'ngx-logger'
import { AccountInputEventsService } from 'src/app/modules/account/services/input-events.service'
import { isPlatformBrowser } from '@angular/common'
import { UserStateService, UserStateType } from 'src/app/core/services/user-state.service'
import { SharedDataService } from '../../../../core/services/shared-data.service'

@Component({
    selector: 'app-modal-options-dentist-select',
    templateUrl: './modal-options-dentist-select.component.html',
    styleUrls: ['./modal-options-dentist-select.component.scss'],
    standalone: false
})

export class ModalOptionsDentistSelectComponent implements OnInit {
  @Input() breakpoints: any = {}
  @Input() dentistData
  @Output() selectDentist: EventEmitter<any> = new EventEmitter()
  @Output() showDentistTitle: EventEmitter<boolean> = new EventEmitter()
  currentLocation = {
    lat: 0,
    lng: 0
  }
  showLoader: boolean
  enteredData
  expiryDate
  filtersInfo
  invalidStateErrorType = UserStateType.noSelectedDentist
  showNoDentistSelectError: boolean = false
  selectedDentistInfo = null
  showEnterDentistInfo: boolean = true
  showDentistFilters: boolean = false
  showDentistList: boolean = false
  showSelectedDentistInfo: boolean = false
  showSelectedDentistConfirmation = false
  showPreApprovedPopup: boolean = false
  findInputs: FormGroup
  filterInputs: FormGroup
  constructor(@Inject(PLATFORM_ID) private platformId: object,
  public sharedDataService: SharedDataService,
  private _inputEventsService: AccountInputEventsService, private _api: ApiService, private _fb: FormBuilder, public dentist: DentistService, private logger: NGXLogger ) {
    this.findInputs = _fb.group({
      dentistName: [''],
      practiceName: [''],
      location: [''],
    })
  }
 // @ViewChild('places') places: GooglePlaceDirective
  placesOptions = {
    // types: [
    //   'street_number',
    //   'route',
    //   'locality',
    //   'administrative_area_level_1',
    //   'administrative_area_level_3',
    //   'administrative_area_level_2',
    // ],
    componentRestrictions: { country: 'us' },
  }
  inputList = ['dentistName', 'location']
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this._inputEventsService.setupInputEvents(document, {}, this.inputList)
      }, 300)
    }
    this.dentist.loanInfo = this.dentistData?.lastResponse
    this.expiryDate = this.dentist.loanInfo.preApprovalExpiryDate
    // this._api.getDentistFiltersInfo().subscribe((t) => {
    //   this.filtersInfo = t
    // })
  }
  inputItemClick(event: any): void {
    inputSelectAriaCheckActiveState(event.currentTarget)
  }

  dentistHeader() {
    if (this.showDentistFilters) {
      return 'Filters'
    }
    if (this.showSelectedDentistInfo) {
      return 'Select Dentist'
    }
    return 'Find Your Dentist'
  }
  public autoCompleteOnChange(address: any): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const parsedAddress = parseAddress(this, address)
    this.currentLocation.lat = address.geometry.location.lat()
    this.currentLocation.lng = address.geometry.location.lng()
    const fmt_addresses = address.formatted_address.split(', ')
    let addr = fmt_addresses[0] + ', ' + parsedAddress.administrative_area_level_1.short_name
    this.findInputs.controls.location.setValue(addr)
    // this.findInputs.controls.location.enable()
    const addrInput = document.getElementById('modal__input_location') as any
    setTimeout(()=>{
      addrInput.classList.remove('input-area__inactive')
      addrInput.classList.add('input-area__active')
    }, 0)
    
  }
  findDentist() {
    if(this.findInputs.invalid){
      this.findInputs.markAllAsTouched()
      return
    }
    this.filtersInfo = this.findInputs.value.dentistName ? this.findInputs.value.dentistName + ' / ' + this.findInputs.value.location : this.findInputs.value.location
    let inputVals = this.findInputs.value
    // let currrentLocation = {}
    // return
    // navigator.geolocation.getCurrentPosition((position) => {
    //   if (position) {
    //     console.log("Latitude: " + position.coords.latitude +
    //       "Longitude: " + position.coords.longitude);
    //     let lat = position.coords.latitude;
    //     let lng = position.coords.longitude;
    //     console.log(lat);
    //     console.log(lng);
    //   }
    // },
    //   (error) => console.log(error));

    // let body = {
    //   currrentLocation: {
    //     latitude: 40.542292464,
    //     longitude: -74.372681583,
    //   },
    //   searchText: '',
    //   practiceSearchText: '',
    //   filters: {
    //     preferredDentists: false,
    //     specialty: '',
    //     radius: 10,
    //   },
    //   officeUuid: 'caea8bdb-cdef-11eb-8745-0e778d464f81',
    //   rowOffset: 0,
    //   rowLimit: 20,
    // }
    let body = {
      // currentLocation: {
      //       latitude: 40.542292464,
      //       longitude: -74.372681583,
      //     },
      currentLocation: {
        latitude: this.currentLocation.lat ? this.currentLocation.lat : this.dentist.userCoords.deviceLatitude,
        longitude: this.currentLocation.lng ? this.currentLocation.lng : this.dentist.userCoords.deviceLongitude,
      },
      searchText: inputVals.dentistName,
      practiceSearchText: '',
      filters: {
        preferredDentists: true,
        specialty: 'All',
        radius: 10,
      },
      officeUuid: null,
      rowOffset: 0,
      rowLimit: 20,
    }
    this.showLoader = true
    this._api.getDentistList(body).subscribe((t) => {
      this.dentist.dentistListdata = t
      // this._dentist.dentistListdata.data.providers = {}
      // console.log(this._dentist.dentistListdata)
      this.showEnterDentistInfo = false
      this.showDentistList = true
      this.showDentistTitle.emit(true)
      this.showLoader = false
    }, ()=> this.showLoader = false)
  }
  // acceptFilters(certified?: boolean) {
  //   let inputVals = this.findInputs.value
  //   let values = this.filterInputs.value
  //   let body = {
  //     currrentLocation: {
  //       latitude: this.dentist.userCoords.deviceLatitude,
  //       longitude: this.dentist.userCoords.deviceLongitude,
  //     },
  //     searchText: inputVals.dentistName,
  //     practiceSearchText: inputVals.practiceName,
  //     filters: {
  //       preferredDentists: certified ? true : values.certified,
  //       specialty: values.services,
  //       radius: values.radius,
  //     },
  //     officeUuid: this.dentist.loanInfo.officeUUID,
  //     rowOffset: 0,
  //     rowLimit: 20,
  //   }
  //   this._api.getDentistList(body).subscribe((t) => {
  //     this.dentist.dentistListdata = t
  //     this.showDentistFilters = false
  //     this.showPreApprovedPopup = false
  //     this.showSelectedDentistConfirmation = false
  //     this.showSelectedDentistInfo = false
  //     this.showDentistList = true
  //     this.showDentistTitle.emit(true)
  //   })
  // }
  dentistChoosen(e: any) {
    this.selectedDentistInfo = e
    // this.showDentistList = false
    // this.showSelectedDentistInfo = true
  }
  // changeDentist() {
  //   this.showPreApprovedPopup = false
  //   this.showSelectedDentistConfirmation = false
  //   this.showSelectedDentistInfo = false
  //   this.showDentistList = true
  // }
  // getCertifiedDentistList() {
  //   this.acceptFilters(true)
  // }
  confirmDentist() {
    // this.showPreApprovedPopup = true
    // this.showSelectedDentistConfirmation = false
    this.postSelectDentist()
    // this.selectDentist.emit(Math.random())
  }

  approveDentist() {
    this.selectDentist.emit(null)
  }

  skipSelectDentist(){
    this.selectDentist.emit(null)
    this.showDentistTitle.emit(false)
  }

  reEnterData(){
    this.selectedDentistInfo = null
    this.showEnterDentistInfo = true
    this.showDentistList = false
    this.showDentistTitle.emit(false)
  }

  enterLocation(e){
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const addrInput = document.getElementById('modal__input_location') as any
    setTimeout(()=>{
      addrInput.classList.remove('input-area__inactive')
      addrInput.classList.add('input-area__active')
    }, 0)
    this.findInputs.controls.location.setErrors({})
  }

  addNewCards(e: number){
    let inputVals = this.findInputs.value
    let body = {
      currentLocation: {
        latitude: this.currentLocation.lat ? this.currentLocation.lat : this.dentist.userCoords.deviceLatitude,
        longitude: this.currentLocation.lng ? this.currentLocation.lng : this.dentist.userCoords.deviceLongitude,
      },
      searchText: inputVals.dentistName,
      practiceSearchText: '',
      filters: {
        preferredDentists: true,
        specialty: 'All',
        radius: 10,
      },
      officeUuid: null,
      rowOffset: e,
      rowLimit: 20,
    }
    this.showLoader = true
    this._api.getDentistList(body).subscribe((t) => {
      // let arr = this._dentist.dentistListdata.data.providers
      this.dentist.dentistListdata.data.providers = this.dentist.dentistListdata.data.providers.concat(t.data.providers)
      let arr = Object.assign({}, this.dentist.dentistListdata)
      this.dentist.dentistListdata = arr
      // console.log(this.dentist.dentistListdata.data.providers)
      // this._dentist.dentistListdata = t
      this.showLoader = false
    }, ()=> this.showLoader = false)
  }

  postSelectDentist() {
    if(!this.selectedDentistInfo){
      this.showNoDentistSelectError = true
      setTimeout(()=> this.showNoDentistSelectError = false, 5000)
      return
    }
    this.showLoader = true
    // const body = {
    //   userId: this._dentist.loanInfo.userId || null,
    //   loanId: this._dentist.loanInfo.loanId || null,
    //   officeUUId: this.selectedDentistInfo.officeUUid,
    //   providerUUId: this.selectedDentistInfo.providerUUid,
    //   netWorkUUId: this._dentist.loanInfo.networkUUID || null,
    //   icwPreferred: this.selectedDentistInfo.icwPreferred,
    // }
    // console.log(this.selectedDentistInfo, this._dentist.loanInfo)
    const body = {
      // userId: this._dentist.loanInfo.userId || null,
      // loanId: this._dentist.loanInfo.loanId || null,
      officeUUID: this.selectedDentistInfo.officeUUid || null,
      providerUUID: this.selectedDentistInfo.providerUUid || null,
      networkUUID: this.selectedDentistInfo.networkExternalId || null,
      icwPreferred: this.selectedDentistInfo.icwPreferred || null,
      providerType: this.selectedDentistInfo.type
    }
    this.selectDentist.emit(body)
    // this._api.sendSelectDentist(body).subscribe((t) => {
    //   this._api
    //     .getLoanOptions(this._dentist.loanInfo.userId, this._dentist.loanInfo.loanId)
    //     .subscribe((t) => {
    //       this._dentist.loanInfo = t.data
    //       if (!this.selectedDentistInfo.icwPreferred) {
    //         this.showPreApprovedPopup = true
    //         this.showSelectedDentistConfirmation = false
    //         this.showSelectedDentistInfo = false
    //         return
    //       }
    //       this.selectDentist.emit(Math.random())
    //     })
    // })
    null
  }
// @Component({
//   selector: 'app-modal-options-dentist-select',
//   templateUrl: './modal-options-dentist-select.component.html',
//   styleUrls: ['./modal-options-dentist-select.component.scss'],
// })
// export class ModalOptionsDentistSelectComponent implements OnInit {
//   @Input() dentistData
//   @Output() selectDentist: EventEmitter<any> = new EventEmitter()
//   expiryDate
//   filtersInfo
//   selectedDentistInfo
//   showEnterDentistInfo: boolean = true
//   showDentistFilters: boolean = false
//   showDentistList: boolean = false
//   showSelectedDentistInfo: boolean = false
//   showSelectedDentistConfirmation = false
//   showPreApprovedPopup: boolean = false
//   findInputs: FormGroup
//   filterInputs: FormGroup
//   center = {
//     lat: 40.542292464,
//     lng: -74.372681583,
//   }
//   options = {
//     scrollwheel: false,
//     panControl: false,
//     zoomControl: false,
//     mapTypeControl: false,
//     scaleControl: false,
//     streetViewControl: false,
//     overviewMapControl: false,
//     rotateControl: false,
//     maxZoom: 15,
//     minZoom: 8,
//   }
//   constructor(private _api: ApiService, private _fb: FormBuilder, private _dentist: DentistService) {
//     this.findInputs = _fb.group({
//       dentistName: [''],
//       practiceName: [''],
//       practiceLocation: [''],
//     })
//     this.filterInputs = _fb.group({
//       radius: [10],
//       services: [''],
//       certified: [false],
//     })
//   }

//   ngOnInit(): void {
//     this._dentist.loanInfo = this.dentistData?.lastResponse
//     this.expiryDate = this._dentist.loanInfo.preApprovalExpiryDate
//     this._api.getDentistFiltersInfo().subscribe((t) => {
//       this.filtersInfo = t
//     })
//   }
//   inputItemClick(event: any): void {
//     inputSelectAriaCheckActiveState(event.currentTarget)
//   }

//   dentistHeader() {
//     if (this.showDentistFilters) {
//       return 'Filters'
//     }
//     if (this.showSelectedDentistInfo) {
//       return 'Select Dentist'
//     }
//     return 'Find Your Dentist'
//   }
//   findDentist() {
//     let inputVals = this.findInputs.value
//     let currrentLocation = {}
//     // return
//     // navigator.geolocation.getCurrentPosition((position) => {
//     //   if (position) {
//     //     console.log("Latitude: " + position.coords.latitude +
//     //       "Longitude: " + position.coords.longitude);
//     //     let lat = position.coords.latitude;
//     //     let lng = position.coords.longitude;
//     //     console.log(lat);
//     //     console.log(lng);
//     //   }
//     // },
//     //   (error) => console.log(error));

//     // let body = {
//     //   currrentLocation: {
//     //     latitude: 40.542292464,
//     //     longitude: -74.372681583,
//     //   },
//     //   searchText: '',
//     //   practiceSearchText: '',
//     //   filters: {
//     //     preferredDentists: false,
//     //     specialty: '',
//     //     radius: 10,
//     //   },
//     //   officeUuid: 'caea8bdb-cdef-11eb-8745-0e778d464f81',
//     //   rowOffset: 0,
//     //   rowLimit: 20,
//     // }
//     let body = {
//       currentLocation: {
//             latitude: 40.542292464,
//             longitude: -74.372681583,
//           },
//       // currentLocation: {
//       //   latitude: this._dentist.userCoords.deviceLatitude,
//       //   longitude: this._dentist.userCoords.deviceLongitude,
//       // },
//       searchText: inputVals.dentistName,
//       practiceSearchText: inputVals.practiceName,
//       filters: {
//         preferredDentists: false,
//         specialty: '',
//         radius: 10,
//       },
//       officeUuid: this._dentist.loanInfo.officeUUID,
//       rowOffset: 0,
//       rowLimit: 20,
//     }
//     this._api.getDentistList(body).subscribe((t) => {
//       this._dentist.dentistListdata = t
//       this.showEnterDentistInfo = false
//       this.showDentistList = true
//     })
//     // "{{coreSecDentistSearchBaseUrl}}/api/security/v1/doctorpractice/search"
//     // console.log(JSON.parse("{\r\n    \"currrentLocation\": {\r\n        \"latitude\": 40.542292464,\r\n        \"longitude\": -74.372681583\r\n    },\r\n    \"searchText\": \"Vitale\",\r\n    \"practiceSearchText\": \"\",\r\n    \"filters\": {\r\n        \"preferredDentists\": false,\r\n        \"radius\": 10\r\n    },\r\n    \"officeUuid\": null,\r\n    \"rowOffset\": 0,\r\n    \"rowLimit\": 20\r\n}",))
//     // console.log('aa')
//   }
//   openFilters() {
//     this.showDentistList = false
//     this.showDentistFilters = true
//   }
//   acceptFilters(certified?: boolean) {
//     let inputVals = this.findInputs.value
//     let values = this.filterInputs.value
//     let body = {
//       currrentLocation: {
//         latitude: this._dentist.userCoords.deviceLatitude,
//         longitude: this._dentist.userCoords.deviceLongitude,
//       },
//       searchText: inputVals.dentistName,
//       practiceSearchText: inputVals.practiceName,
//       filters: {
//         preferredDentists: certified ? true : values.certified,
//         specialty: values.services,
//         radius: values.radius,
//       },
//       officeUuid: this._dentist.loanInfo.officeUUID,
//       rowOffset: 0,
//       rowLimit: 20,
//     }
//     this._api.getDentistList(body).subscribe((t) => {
//       this._dentist.dentistListdata = t
//       this.showDentistFilters = false
//       this.showPreApprovedPopup = false
//       this.showSelectedDentistConfirmation = false
//       this.showSelectedDentistInfo = false
//       this.showDentistList = true
//     })
//   }
//   dentistChoosen(e: any) {
//     this.center.lat = e.latitude
//     this.center.lng = e.longitude
//     this.selectedDentistInfo = e
//     this.showDentistList = false
//     this.showSelectedDentistInfo = true
//   }
//   submitDentist() {
//     if (this.selectedDentistInfo.icwPreferred) {
//       this.postSelectDentist()
//       return
//     }
//     const body = {
//       userId: this._dentist.loanInfo.userId,
//       loanId: this._dentist.loanInfo.loanId,
//       officeUUId: this.selectedDentistInfo.officeUUid,
//       providerUUId: this.selectedDentistInfo.providerUUId,
//       netWorkUUId: this._dentist.loanInfo.networkUUID,
//       icwPreferred: this.selectedDentistInfo.icwPreferred,
//     }
//     this._api.sendSelectDentist(body).subscribe((t) => {
//       this._api
//         .getLoanOptions(this._dentist.loanInfo.userId, this._dentist.loanInfo.loanId)
//         .subscribe((t) => {
//           this._dentist.loanInfo = t.data
//           this.dentistData = t.data
//           this.showSelectedDentistConfirmation = true
//         })
//     })
//   }
//   changeDentist() {
//     this.showPreApprovedPopup = false
//     this.showSelectedDentistConfirmation = false
//     this.showSelectedDentistInfo = false
//     this.showDentistList = true
//   }
//   getCertifiedDentistList() {
//     this.acceptFilters(true)
//   }
//   confirmDentist() {
//     // this.showPreApprovedPopup = true
//     // this.showSelectedDentistConfirmation = false
//     this.postSelectDentist()
//     // this.selectDentist.emit(Math.random())
//   }

//   approveDentist() {
//     this.selectDentist.emit(Math.random())
//   }

//   postSelectDentist() {
//     const body = {
//       userId: this._dentist.loanInfo.userId,
//       loanId: this._dentist.loanInfo.loanId,
//       officeUUId: this.selectedDentistInfo.officeUUid,
//       providerUUId: this.selectedDentistInfo.providerUUId,
//       netWorkUUId: this._dentist.loanInfo.networkUUID,
//       icwPreferred: this.selectedDentistInfo.icwPreferred,
//     }
//     this._api.sendSelectDentist(body).subscribe((t) => {
//       this._api
//         .getLoanOptions(this._dentist.loanInfo.userId, this._dentist.loanInfo.loanId)
//         .subscribe((t) => {
//           this._dentist.loanInfo = t.data
//           if (!this.selectedDentistInfo.icwPreferred) {
//             this.showPreApprovedPopup = true
//             this.showSelectedDentistConfirmation = false
//             this.showSelectedDentistInfo = false
//             return
//           }
//           this.selectDentist.emit(Math.random())
//         })
//     })
//   }
}
